import axios from 'axios';
import React, { useEffect } from 'react';
import Doctor from '../../Doctor/Doctor';
import AppoinmentBanner from '../AppoinmentBanner/AppoinmentBanner';
import Banner from '../Banner/Banner';
import Header from '../Header/Header';
import Services from '../Services/Services';

const Home = () => {
    //     const F=new FormData()
    //     F.append("currency","USD")
    //  useEffect(()=>{
    //     axios({
    //         method: 'post',
    //         data:F,
    //         url: `https://findexx.net/api/app/markets`,
    //         headers: {
    //             "api_key": "711e88a8c03b19a6fbd4fcab554f29d6",
    //             "Access-Control-Allow-Origin": "*",
    //             'Access-Control-Allow-Headers':'*',
    //             'Access-Control-Allow-Credentials':true,
    //             "Content-Type": "multipart/form-data",
    //             'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    //         },
    //       }).then(res=>console.log(res.data));
    //  },[F])
    //   fetch('https://findexx.net/api/app/markets', {
    //     method: 'POST',
    //     headers: {
    //         'X-API-KEY': '711e88a8c03b19a6fbd4fcab554f29d6',
    //         "Content-Type": "multipart/form-data",
    //     },
    //     body:F,
    // })
    // .then(response => response.json())
    // .then((response) => console.log(response))
    // .catch(error => console.error(error));
    return (
        <div>
            <Header></Header>
            <Banner></Banner>
            <Services></Services>
            <AppoinmentBanner></AppoinmentBanner>
            <Doctor></Doctor>
        </div>
    );
};

export default Home;